// extracted by mini-css-extract-plugin
export default {"summary":"summary_summary__cEtHd","summaryCard":"summary_summaryCard__RriHB"};